





















import Vue from 'vue'
import { mapState } from 'vuex'
import { Action, Getter } from 'vuex-class'
import Component from 'vue-class-component'
import { Config, User } from '@/store/context/contextTypes'
import { ProviderType } from '@/utils/identifyFields/providers/providerTypes'
import GetIdentifyData from '@/utils/identifyFields/countries'
import ProviderSelector from '@/components/ProviderSelector.vue'

// define used modules
const _CONTEXT_: string = 'context'

@Component({
  computed: {
    ...mapState({
      userDeviceExists: (state: any): User => state.context.userDeviceExists,
      user: (state: any): User => state.context.user,
      config: (state: any): User => state.context.config,
      identifyWizardStep: (state: any): User => state.context.identifyWizardStep,
      isLoading: (state: any): User => state.context.isLoading
    })
  },
  components: {
    ProviderSelector
  }
})

export default class TopContainer extends Vue {
  config: Config
  user: User
  identifyWizardStep: number
  availableProviders: Array<Object>

  @Action('resetIdentifiedUser', { namespace: _CONTEXT_ }) resetIdentifiedUser: any
  @Action('resetEditUserData', { namespace: _CONTEXT_ }) resetEditUserData: any
  @Action('setUserDeviceExists', { namespace: _CONTEXT_ }) setUserDeviceExists: any
  @Action('setCheckUserDevice', { namespace: _CONTEXT_ }) setCheckUserDevice: any
  @Action('setEditUser', { namespace: _CONTEXT_ }) setEditUser: any
  @Action('setIdentifyProvider', { namespace: _CONTEXT_ }) setIdentifyProvider: any
  @Action('setIdentifyProviderId', { namespace: _CONTEXT_ }) setIdentifyProviderId: any
  @Action('setWizardRedirectFields', { namespace: _CONTEXT_ }) setWizardRedirectFields: any
  @Action('resetDidAuthToken', { namespace: _CONTEXT_ }) resetDidAuthToken: any
  @Getter('identifiedUser', { namespace: _CONTEXT_ }) identifiedUser: boolean

  beforeMount () {
    const identifyContent = this.identifyContent
    this.availableProviders = identifyContent.providers
  }

  get identifyContent (): any {
    const { country, identifyProvider, identifyFields } = this.config
    return GetIdentifyData[country](identifyFields)
  }

  get getIdentifyField (): any {
    const fieldId = this.config.identifyFields[this.identifyWizardStep]
    return this.$t(fieldId)
  }

  resetUserExists () {
    this.setUserDeviceExists(false)
    this.setCheckUserDevice(false)
    this.resetIdentifiedUser()
    this.resetDidAuthToken()

    this.handleProviderChange()
  }

  getSelectedProvider (): ProviderType {
    const { identifyProvider } = this.config
    const provider: ProviderType = this.identifyContent.providers.find((provider: ProviderType) => (provider.id === identifyProvider))
    if (!provider) {
      console.error('No provider found matching: ', identifyProvider + ' in the selected country. Fallback to first provider')
      const firstProvider = this.identifyContent.providers[0]
      this.setIdentifyProviderId(firstProvider.id)
      return firstProvider
    } else {
      return provider
    }
  }

  async handleProviderChange () {
    const { country, identifyProvider, identifyFields } = this.config
    if (identifyProvider === 'manual') {
      this.setUserDeviceExists(false)
      this.setEditUser(true)
    } else {
      this.resetIdentifiedUser()
      this.setEditUser(false)
      const identifyProviderObject = this.getSelectedProvider()
      this.setIdentifyProvider(identifyProviderObject)
    }
  }
}
